import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Reveal, RevealLines } from './Reveal';
import { FAQS } from '../data/site';
import { Plus } from 'lucide-react';

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-32 md:py-48 px-6 md:px-10 max-w-[1600px] mx-auto" data-testid="faq-section">
      <div className="grid grid-cols-12 gap-6 md:gap-10">
        <Reveal className="col-span-12 md:col-span-3">
          <div className="flex md:flex-col items-baseline md:items-start gap-4">
            <span className="font-mono text-gold text-sm tracking-[0.3em]">07 —</span>
            <span className="overline">Vos questions</span>
          </div>
        </Reveal>
        <div className="col-span-12 md:col-span-9">
          <h2 className="font-serif leading-[0.95] tracking-tight mb-14" style={{ fontSize: 'clamp(2.5rem, 6vw, 6rem)' }}>
            <RevealLines lines={['Les réponses,', <span key="i" className="italic text-char/50">tout simplement.</span>]} />
          </h2>

          <div className="border-t border-char/10">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q} className="border-b border-char/10" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 py-6 md:py-8 text-left group"
                    data-testid={`faq-btn-${i}`}
                  >
                    <span className="flex items-center gap-6">
                      <span className="font-mono text-gold text-xs">{String(i + 1).padStart(2, '0')}</span>
                      <span className="font-serif text-2xl md:text-3xl leading-tight group-hover:text-gold transition-colors">
                        {f.q}
                      </span>
                    </span>
                    <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.4 }} className="flex-shrink-0 text-gold">
                      <Plus size={22} strokeWidth={1.4} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: [0.7, 0, 0.2, 1] }}
                        className="overflow-hidden"
                      >
                        <div className="pb-8 pl-12 md:pl-14 pr-6 max-w-3xl text-char/70 leading-relaxed">
                          {f.a}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
